import { enableProdMode, ErrorHandler, importProvidersFrom, Injectable } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
// import * as Sentry from "@sentry/angular";
// import { Integrations } from "@sentry/tracing";
import * as Sentry from "@sentry/angular";
// import { BrowserTracing } from "@sentry/tracing";

import * as packageInfo from '../package.json';

import { AppEnvironments } from './app/_constants';
import { environment } from './environments/environment';

import { bootstrapApplication, Title } from '@angular/platform-browser';
import { provideRouter, Router, Routes } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app/components/app.component';
import { AuthGuard } from './app/_guards/auth.guard';
import { AppSettingsComponent } from './app/components/app-settings/app-settings.component';
import { BookingCompleteComponent } from './app/components/booking/booking-complete/booking-complete.component';
import { BookingListComponent } from './app/components/booking/booking-list/booking-list/booking-list.component';
import { BookingComponent } from './app/components/booking/booking.component';
import { historyComponent } from './app/components/history/history.component';
import { HomeComponent } from './app/components/home/home.component';
import { ItemsComponent } from './app/components/items/items.component';
import { LoginComponent } from './app/components/login/login.component';
import { OrderComponent } from './app/components/order/order.component';
import { QuotesComponent } from './app/components/quotes/quotes.component';
import { SettingsComponent } from './app/components/settings/settings.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CurrencyPipe } from '@angular/common';
import { AlertService } from './app/_services/alert.service';
import { AppSettingsServiceProvider } from './app/_services/app-settings.service';
import { AuthenticationService } from './app/_services/authentication.service';
import { BookingServiceProvider } from './app/_services/booking.service';
import { CryptoService } from './app/_services/crypto.service';
import { CustomerServiceProvider } from './app/_services/customer.service';
import { DialogCloseService } from './app/_services/dialogClose.service';
import { GatewayServiceProvider } from './app/_services/gateway.service';
import { ItemServiceProvider } from './app/_services/item.service';
import { LocationServiceProvider } from './app/_services/location.service';
import { PDFService } from './app/_services/pdf.service';
import { QuotesServiceProvider } from './app/_services/quotes.service';
import { RequestHelperProvider } from './app/_services/request-helper';
import { RouteDataProvider } from './app/_services/route-data.provider';
import { SentryLoggingService } from './app/_services/sentry.service';
import { SignalRService } from './app/_services/signalr.service';
import { StagingServiceProvider } from './app/_services/staging.service';
import { StorageServiceProvider } from './app/_services/storage.service';
import { UtilServiceProvider } from './app/_services/util.service';
import { VersionCheckService } from './app/_services/version_check_service';
import { AppConfig } from './app/app.config';
import { Global } from './app/globals';
import { provideAnimations } from '@angular/platform-browser/animations';
//import { ResponseNormalizerInterceptor } from './app/_services/response-normalizer.interceptor';

const appRoutes: Routes = [
  { path: 'home', component: HomeComponent, canActivate: [AuthGuard], data: { title: 'Home' } },
  { path: 'items', component: ItemsComponent, canActivate: [AuthGuard], data: { title: 'Quantities' } },
  { path: 'booking', component: BookingComponent, canActivate: [AuthGuard], data: { title: 'Sales' } },
  { path: 'order', component: OrderComponent, canActivate: [AuthGuard], data: { title: 'Order' } },
  { path: 'bookingcomplete', component: BookingCompleteComponent, canActivate: [AuthGuard], data: { title: 'Transaction Complete' } },
  { path: 'bookinglist', component: BookingListComponent, canActivate: [AuthGuard], data: { title: 'Booking list' } },
  { path: 'settings', component: SettingsComponent, canActivate: [AuthGuard], data: { title: 'Settings' } },
  { path: 'appsettings', component: AppSettingsComponent, data: { title: 'App settings' } },
  { path: 'quotes', component: QuotesComponent, canActivate: [AuthGuard], data: { title: 'Quotes' } },
  { path: 'history', component: historyComponent, canActivate: [AuthGuard], data: { title: 'History' } },
  { path: 'login', component: LoginComponent, data: { title: 'Login' } },
  { path: '**', redirectTo: '/home', pathMatch: 'full' },

];


if (environment.production) {
  enableProdMode();
}

let version = JSON.parse(JSON.stringify(packageInfo)).version;
// console.log("app-version =>", version);
//Deprecation Notice: From SDK versions >= 7.47.0 onwards, the @sentry/tracing package is officially deprecated and it has merged into @Sentry/vue.
// import Integrations from "@sentry/browser";
// let version: string = "3.0.251";

// @Injectable({
//   providedIn: 'root' 
// })
// export class SentryErrorHandler implements ErrorHandler {
//   constructor() { }
//   handleError(error) {
//     // Check if the error is an HTTP cancellation error

//     const isCanceledError =
//       error?.name === 'CanceledError' ||
//       error?.message?.includes('canceled') ||
//       error?.message?.includes('null');

//     if (isCanceledError) {
//       //console.warn('Cancellation error ignored:', error);
//       return; // Do not pass cancellation errors to Sentry
//     }

//     // Capture other errors in Sentry
//     const eventId = Sentry.captureException(error.originalError || error);
//     // Optionally show a report dialog (commented out by default)
//     // Sentry.showReportDialog({ eventId });
//   }
// }

// Your Sentry initialization should look like this:
Sentry.init({
  dsn: "https://9934265640204975a41f92524bb3c8cb@o335354.ingest.sentry.io/5202527",
  environment: getEnvironment(),
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    })
  ],
  // Add tracing configuration at root level
  tracePropagationTargets: [  // 🚨 Also required here for full configuration
    "localhost",
    "salesreviewctd.agris.com",
    "salesreview.agris.com",
    /^\//
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

function getEnvironment() {
  let url = window.location.host;
  let env = "";
  if (process.env.NODE_ENV === AppEnvironments.Production) {
    if (url.indexOf("salesctd") !== -1) env = AppEnvironments.CTD;
    else env = AppEnvironments.Production;
  } else env = AppEnvironments.Development;
  return env;
}

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(appRoutes),
    provideHttpClient(withInterceptorsFromDi()),
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: ResponseNormalizerInterceptor,
    //   multi: true
    // },
    importProvidersFrom(NgxSpinnerModule),
    provideAnimations(), // For full animations support
    AuthGuard,
    AlertService,
    AuthenticationService,
    Global,
    SignalRService,
    CryptoService,
    CurrencyPipe,
    StorageServiceProvider,
    RequestHelperProvider,
    GatewayServiceProvider,
    AppSettingsServiceProvider,
    StagingServiceProvider,
    CustomerServiceProvider,
    ItemServiceProvider,
    LocationServiceProvider,
    QuotesServiceProvider,
    DialogCloseService,
    RouteDataProvider,
    AppConfig,
    BookingServiceProvider,
    Title,
    PDFService,
    { provide: AppConfig, useValue: window['APP_DATA'] },
    { provide: ErrorHandler, useClass: SentryLoggingService },
    UtilServiceProvider,
    VersionCheckService,
  ]
}).catch(err => console.error(err));
